import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import {useAppNavigation} from "../hooks/useAppNavigation";

const Redirect = () => {
  const { instance } = useMsal();
  const {goToLogin, goToApplications} = useAppNavigation();

  useEffect(() => {
    const handleMsalRedirect = async () => {
      try {
        const response = await instance.handleRedirectPromise();
  
        if (response) {
        }
  
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
          const account = accounts[0];
  
                 // Retrieving representativeCode directly from idTokenClaims
          const userId = account?.idTokenClaims?.extension_representativeCode || account?.idTokenClaims?.email || account?.idTokenClaims?.name;
  
          if (userId) {
            goToApplications();
          } else {
            goToLogin();
          }
        } else {
          goToLogin();
        }
      } catch (error) {
        console.error("Error during handleRedirectPromise:", error);
        goToLogin();
      }
    };
  
    handleMsalRedirect();
  }, [instance]);
  
  return null;
};

export default Redirect;
